// src/App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminDashboard from "./components/AdminDashboard";
import EsquinitaMenu from "./components/EsquinitaMenu";
import CamiDelMar from "./components/CamiDelMar";
import BlaiNueveMenu from "./components/BlaiNueveMenu";
import EmporiumMenu from "./components/EmporiumMenu";
import BeverageProducts from "./components/BeverageProducts";
import HomePage from "./components/HomePage";
import LoginPage from "./components/LoginPage";
import PrivateRoute from "./PrivateRoute"; // Importar la ruta privada
import BulkUpload from "./components/BulkUpload";
import ExcelUploader from "./components/ExcelUploader";
import ExcelDownloader from "./components/ExcelDownloader";
import FoodTruckMenu from "./components/FoodTruckMenu";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/excel"
          element={<ExcelUploader collectionName="bebidas-b9" />}
        />
        <Route
          path="/excelD"
          element={<ExcelDownloader collectionName="bebidas-cami" />}
        />

        <Route path="/emporium/:category?" element={<EmporiumMenu />} />
        <Route path="/foodtruck" element={<FoodTruckMenu />} />

        <Route path="/esquinita/:category?" element={<EsquinitaMenu />} />
        <Route path="/blai9/:category?" element={<BlaiNueveMenu />} />
        {/* Ruta para BeverageProducts */}
        <Route path="/beverages" element={<BeverageProducts language="en" />} />
        {/* Ruta protegida para el panel de administración */}
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/upload" element={<BulkUpload />} />
      </Routes>
    </Router>
  );
}

export default App;
